import React from "react";

import "./ProjectRightClickMenu.scss";

export type ProjectRightClickMenuProps = {
  cx?: string;
  list: { text: string; click: any }[];
  onMouseLeave: React.MouseEventHandler<HTMLUListElement>;
  pos: { x: number; y: number };
};

export const ProjectRightClickMenu: React.FC<ProjectRightClickMenuProps> = ({
  cx = "",
  list,
  onMouseLeave,
  pos,
}) => {
  return (
    <ul
      className={`ProjectRightClickMenu ${cx}`}
      onMouseLeave={onMouseLeave}
      style={{ top: `${pos.y - 10}px`, left: `${pos.x - 10}px` }}
    >
      {list.map(({ text, click }, idx) => (
        <li key={`${text}-${idx}`} onClick={click}>
          {text}
        </li>
      ))}
    </ul>
  );
};
